import React, { useEffect, useState } from "react";
import Footsteps from "@coninsa-ui/react-footsteps";
import { Toaster } from "@coninsa/core";
import { queryString } from "@coninsa/utils";
import { useQuery } from "@apollo/client";
import { CURRENT_USER_QUERY } from "./graphql/queries";

import {
  defaultFieldSettings,
  getNuwweFieldSettings,
  T_fieldSettings,
} from "./api";

import Auth0 from "./slices/Auth0";
import Auth1 from "./slices/Auth1";

import Step1 from "./slices/Step1";
import Step2 from "./slices/Step2";
import Step3 from "./slices/Step3";
import Step4 from "./slices/Step4";
import Step5 from "./slices/Step5";
import Step6 from "./slices/Step6";

const AUTH_0_STEP = -1;
const AUTH_1_STEP = 0;
const FORM_1_STEP = 1;
const FORM_2_STEP = 2;
const FORM_3_STEP = 3;
const FORM_4_STEP = 4;
const FORM_5_STEP = 5;
const FORM_6_STEP = 6;

export default function AdvertiseProperty() {
  const [step, setStep] = useState(-1);
  const { data, loading } = useQuery(CURRENT_USER_QUERY);
  const [fieldSettings, setFieldSettings] =
    useState<T_fieldSettings>(defaultFieldSettings);

  const handleAuthSuccess = () => {
    setStep(step + 1);
  };

  const handleStepSuccess = (nextStep?: number) => {
    if (nextStep) {
      setStep(nextStep);
    } else {
      setStep(step + 1);
    }
  };

  const handleBack = () => {
    setStep(step - 1);
  };

  useEffect(() => {
    const step = queryString.get("step");

    if (step) {
      setStep(Number.parseInt(step));
    }

    async function fetchSettings() {
      const settings = await getNuwweFieldSettings();

      setFieldSettings(settings);
    }

    fetchSettings();
  }, []);

  useEffect(() => {
    queryString.set("step", step);
  }, [step]);

  // Move user to step 1 if it is already logged.
  useEffect(() => {
    if (!loading && data) {
      if (data?.currentUser?.uid !== 0) {
        setStep(1);
      }
    }
  }, [data, loading]);

  const steps = [
    { label: 1, desc: "Preguntas de validación" },
    { label: 2, desc: "Ubicación del inmueble" },
    { label: 3, desc: "Información del inmueble" },
    { label: 4, desc: "Fotos del inmueble" },
    { label: 5, desc: "Tarifas de administración y documentación" },
    { label: 6, desc: "Confirmación" },
  ];

  return (
    <div className="bg-zinc-50">
      <header className="headline is-small">
        <h1>Promocionar un inmueble</h1>
      </header>

      <div className="container py-16">
        {step === AUTH_0_STEP && <Auth0 onSuccess={handleAuthSuccess} />}
        {step === AUTH_1_STEP && <Auth1 onSuccess={handleAuthSuccess} />}

        {step > AUTH_1_STEP && <Footsteps steps={steps} currentStep={step} />}

        {step === FORM_1_STEP && (
          <Step1 onSuccess={handleStepSuccess} fieldSettings={fieldSettings} />
        )}
        {step === FORM_2_STEP && (
          <Step2
            onSuccess={handleStepSuccess}
            fieldSettings={fieldSettings}
            onBack={handleBack}
          />
        )}
        {step === FORM_3_STEP && (
          <Step3 onSuccess={handleStepSuccess} onBack={handleBack} />
        )}
        {step === FORM_4_STEP && (
          <Step4 onSuccess={handleStepSuccess} onBack={handleBack} />
        )}
        {step === FORM_5_STEP && (
          <Step5 onSuccess={handleStepSuccess} onBack={handleBack} />
        )}
        {step === FORM_6_STEP && <Step6 onSuccess={handleStepSuccess} />}
      </div>

      <Toaster position="bottom-right" />
    </div>
  );
}
